import { Avatar, AvatarProps } from '../Avatar';

const ZERO_EX = 'zeroxv2';

export type BridgeAvatarProps = Omit<AvatarProps, 'rounded'> & {
  /**
   * Name of the bridge to display the logo for.
   */
  name: string;
};

const bridgeAvatarRadius = '32%';

/**
 * A data structure mapping bridge protocol names to their logo image filenames.
 */
const bridgeIcons: Record<string, string> = {
  'across': 'across.webp',
  'across_v4': 'across.webp',
  'arbitrum-bridge': 'arbitrum.webp',
  'arbitrum_bridge': 'arbitrum.webp',
  'anyswap-router-v4': 'anyswap.webp',
  'anyswap-router-v6': 'anyswap.webp',
  'base-bridge': 'base.webp',
  'connext': 'connext.webp',
  'hop': 'hop.webp',
  'refuel-bridge': 'refuel.webp',
  'stargate': 'stargate.webp',
  'stargate-v2': 'stargate.webp',
  'symbiosis': 'symbiosis.webp',
  'polygon-bridge': 'polygon.webp',
  'hyphen': 'hyphen.webp',
  'celer': 'celer.webp',
  'cctp': 'cctp.webp',
  'cctp-v2': 'cctp.webp',
  'circle_forwarder_standard': 'cctp.webp',
  'circle_forwarder_fast': 'cctp.webp',
  'optimism-bridge': 'optimism.webp',
  'synapse': 'synapse.webp',
  'zksync-native': 'zksync.webp',
  'zora-bridge': 'zora.webp',
  'scroll-native-bridge': 'scroll.webp',
  'mantle-native-bridge': 'mantle.webp',
  'mode-native-bridge': 'mode.webp',
  'mayan': 'mayan.webp',
  'mayan_swift': 'mayan.webp',
  'mayan_mctp': 'mayan.webp',
  'mayan_fast_mctp': 'mayan.webp',
  'linea': 'linea.webp',
  'near_intents': 'near.webp',
  'relay': 'relay.webp',
  'gaszip': 'gaszip.webp',
  'gas.zip': 'gaszip.webp',
  'gas_zip': 'gaszip.webp',
  'squid': 'squid.webp',
  'squid_coral': 'squid.webp',
};

export const BridgeAvatar = (props: BridgeAvatarProps) => {
  const { name, size = 20, ...otherProps } = props;

  const bridgeSrc = bridgeIcons[name] ? `/images/bridges/${bridgeIcons[name]}` : undefined;
  const processedBridgeSrc = name === ZERO_EX ? '/images/liquidity-providers/0x.webp' : bridgeSrc;

  return (
    <Avatar
      src={processedBridgeSrc}
      alt={`${name} logo`}
      fallbackSrc="/images/chains/none.svg"
      radius={bridgeAvatarRadius}
      size={size}
      {...otherProps}
    />
  );
};
